import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { languagesApi } from 'common/modules/ReactShared';
import { AxiosError } from 'axios';
import { tSharedAppState } from '../../types';
import { IPreferences } from './types';

const initialPreferencesState: IPreferences = {
  allLangs: [],
  targetLangs: []
};
const getSupportedLanguages = createAsyncThunk<
  IPreferences['allLangs'],
  void,
  { rejectValue: AxiosError; state: tSharedAppState }
>(
  'preferences/getSupportedLanguages_request',
  async (_, { getState, rejectWithValue }) => {
    const langs = getState().shared.user.preferences.allLangs;
    if (langs.length) {
      return langs;
    }
    try {
      return await languagesApi.getAllSupportedLanguages();
    } catch (error) {
      return rejectWithValue(error as AxiosError);
    }
  }
);

const getTargetLanguages = createAsyncThunk<
  IPreferences['allLangs'],
  void,
  { rejectValue: AxiosError; state: tSharedAppState }
>('preferences/getTargetLanguages_request', async (_, { getState, rejectWithValue }) => {
  const langs = getState().shared.user.preferences.targetLangs;
  if (langs.length) {
    return langs;
  }
  try {
    return await languagesApi.getAllTargetLanguages();
  } catch (error) {
    return rejectWithValue(error as AxiosError);
  }
});

const profileSlice = createSlice({
  name: 'preferences',
  initialState: initialPreferencesState as IPreferences,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTargetLanguages.fulfilled, (state, action) => {
      if (action.payload) {
        state.targetLangs = action.payload;
      }
    });
    builder.addCase(getSupportedLanguages.fulfilled, (state, action) => {
      if (action.payload) {
        state.allLangs = action.payload;
        state.targetLangs = action.payload.filter((lang) => lang.active);
      }
    });
  }
});

const { reducer } = profileSlice;
export default reducer;

const preferencesActions = {
  getSupportedLanguages,
  getTargetLanguages
};
export { preferencesActions };
